import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  BannerStatus,
  FORM_MODE,
  RootState,
  TCb,
  BannerOutputModel,
  BannerIndexInputModel,
  AppNotifications,
} from "../../../../../models";
import { BannerService } from "../../../../../services";
import { NotificationActions } from "../../../../../store/actions";
import BannerPublishFormPresenter from "./BannerPublishForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./BannerPublishForm.type";
import { loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

class BannerFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      filter: {
        code: "",
      },
      bannerData: {
        active: [],
        inactive: [],
      },
    };
  }

  reorder = (list, startIndex, endIndex) => {
    const result: BannerOutputModel[] = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  // *** Moves an item from one list to another list.
  move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone: BannerOutputModel[] = Array.from(source);
    const destClone: BannerOutputModel[] = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {} as any;
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  getList = (id) => {
    if (id === "droppable") {
      return this.state.bannerData.active;
    } else if (id === "droppable2") {
      return this.state.bannerData.inactive;
    }
  };

  onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    // Xếp thứ tự trong cùng cột
    if (source.droppableId === destination.droppableId) {
      const items = this.reorder(this.getList(source.droppableId), source.index, destination.index);

      if (source.droppableId === "droppable") {
        this.setState({
          bannerData: {
            ...this.state.bannerData,
            active: items,
          },
        });
      } else if (source.droppableId === "droppable2") {
        this.setState({
          bannerData: {
            ...this.state.bannerData,
            inactive: items,
          },
        });
      }
    } else {
      // Kéo thả qua các cột
      const result = this.move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );

      this.setState({
        bannerData: {
          active: result.droppable,
          inactive: result.droppable2,
        },
      });
    }
  };

  onUpdateBannerIndex = (data: BannerIndexInputModel[], cb?: TCb) => {
    BannerService.updateBannerIndex(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update banner position success",
          });
          loadCallback(this.props.onSave);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update banner position failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update banner position failed" });
      });
  };

  onSubmit = () => {
    const data: BannerIndexInputModel[] = [];
    this.state.bannerData.active.forEach((item, index) => {
      var dataObj: BannerIndexInputModel = {
        code: item.code,
        index: index + 1,
      };
      data.push(dataObj);
    });
    if (data.length > 4) {
      this.props.actions.enqueueSnackbar({
        type: AppNotifications.ERROR,
        message: "Maximum number of published banners is 4",
      });
    } else {
      this.onUpdateBannerIndex(data);
    }
  };

  onApplyFilter = () => {
    this.setState(() => {
      let banners: BannerOutputModel[] = this.props.fetchedData.data;

      let activeBanner: BannerOutputModel[] = [];
      let inactiveBanner: BannerOutputModel[] = [];
      banners
        .sort((a, b) => a.index - b.index)
        .forEach((item) => {
          if (item.status === BannerStatus.ACTIVE && item.index !== 0) {
            activeBanner.push(item);
          }
          if (item.status === BannerStatus.ACTIVE && item.index === 0) {
            inactiveBanner.push(item);
          }
        });

      return {
        bannerData: {
          active: activeBanner,
          inactive: inactiveBanner,
        },
      };
    });
  };

  componentDidMount = () => {
    this.onApplyFilter();
  };

  render() {
    return (
      <BannerPublishFormPresenter {...this.props} {...this.state} onDragEnd={this.onDragEnd} onSubmit={this.onSubmit} />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(BannerFormContainer)
);
